import { tr as __tr, useLocale as __useLocale, direction as __direction, localizedField as __localizedField } from "../../i18n/runtime";
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {RequirementsEditor} from '../../components/VisaRequirements';
import CurrencySelect from '../../components/CurrencySelect';
import { Plus, Edit, Trash2, Hotel, Star, MapPin, Phone, Mail, Eye } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '../../components/ui/dialog';
import { useAuth } from '../../context/AuthContext';
import { useLanguage } from '../../i18n/LanguageContext';
import DatabaseLocationInput from '../../components/DatabaseLocationInput';
const API = '/api';
const HotelsPage = () => {
  __useLocale();
  const {
    token
  } = useAuth();
  const {
    language
  } = useLanguage();
  const [hotels, setHotels] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState('');
  const [dialogOpen, setDialogOpen] = useState(false);
  const [editingHotel, setEditingHotel] = useState(null);
  const [formData, setFormData] = useState({
    name_ar: '',
    name_en: '',
    description_ar: '',
    description_en: '',
    city: '',
    country: '',
    address: '',
    stars: 3,
    rooms_count: 0,
    price_per_night: 0,
    currency: '',
    phone: '',
    email: ''
  });
  const headers = {
    Authorization: `Bearer ${token}`
  };
  useEffect(() => {
    fetchHotels();
  }, []);
  const fetchHotels = async () => {
    setLoading(true);
    setErrorMessage('');
    try {
      const res = await axios.get(`${API}/records.php?resource=hotels`, {
        headers
      });
      setHotels(res.data);
    } catch (error) {
      setErrorMessage(error.response?.data?.message || "تعذر تحميل الفنادق");
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  };
  const handleSubmit = async e => {
    e.preventDefault();
    const payload={...formData,requirements_json:JSON.stringify(formData.requirements||[])};
    setErrorMessage('');
    try {
      if (editingHotel) {
        await axios.put(`${API}/records.php?resource=hotels&id=${encodeURIComponent(editingHotel.id)}`, payload, {
          headers
        });
      } else {
        await axios.post(`${API}/records.php?resource=hotels`, payload, {
          headers
        });
      }
      fetchHotels();
      setDialogOpen(false);
      resetForm();
    } catch (error) {
      setErrorMessage(error.response?.data?.message || "تعذر حفظ الفندق");
      console.error('Error:', error);
    }
  };
  const handleEdit = hotel => {
    setEditingHotel(hotel);
    setFormData({...hotel,requirements:JSON.parse(hotel.requirements_json||'[]')});
    setDialogOpen(true);
  };
  const handleDelete = async id => {
    if (window.confirm(language === 'ar' ? "هل أنت متأكد؟" : 'Are you sure?')) {
      try {
        await axios.delete(`${API}/records.php?resource=hotels&id=${encodeURIComponent(id)}`, {
          headers
        });
        fetchHotels();
      } catch (error) {
        setErrorMessage(error.response?.data?.message || "تعذر حذف الفندق");
      }
    }
  };
  const resetForm = () => {
    setEditingHotel(null);
    setFormData({
      name_ar: '',
      name_en: '',
      description_ar: '',
      description_en: '',
      city: '',
      country: '',
      address: '',
      stars: 3,
      rooms_count: 0,
      price_per_night: 0,
      currency: '',
      phone: '',
      email: ''
    });
  };
  return <div className="space-y-6">
      {__tr(errorMessage && <p role="alert" className="text-red-700">{__tr(errorMessage)} <button onClick={fetchHotels}>{__tr("إعادة التحميل")}</button></p>)}
      <div className="flex justify-between items-center">
        <h1 className="text-2xl font-bold text-gray-800">
          <Hotel className="w-6 h-6 inline ml-2" />
          {__tr(language === 'ar' ? "إدارة الفنادق" : 'Hotels Management')}
        </h1>
        <Dialog open={dialogOpen} onOpenChange={setDialogOpen}>
          <DialogTrigger asChild>
            <Button onClick={resetForm} className="bg-[#6B5B95] hover:bg-[#5B4B85]">
              <Plus className="w-4 h-4 ml-2" />{__tr(language === 'ar' ? "إضافة فندق" : 'Add Hotel')}
            </Button>
          </DialogTrigger>
          <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
            <DialogHeader>
              <DialogTitle>{__tr(editingHotel ? language === 'ar' ? "تعديل فندق" : 'Edit Hotel' : language === 'ar' ? "إضافة فندق" : 'Add Hotel')}</DialogTitle>
            </DialogHeader>
            <form onSubmit={handleSubmit} className="space-y-4">
              {__tr(errorMessage && <p role="alert" className="text-red-700">{__tr(errorMessage)}</p>)}
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="text-sm text-gray-600">{__tr("الاسم (عربي)")}</label>
                  <Input value={formData.name_ar} onChange={e => setFormData({
                  ...formData,
                  name_ar: e.target.value
                })} required />
                </div>
                <div>
                  <label className="text-sm text-gray-600">{__tr("Name (English)")}</label>
                  <Input value={formData.name_en} onChange={e => setFormData({
                  ...formData,
                  name_en: e.target.value
                })} required />
                </div>
                <div>
                  <label className="text-sm text-gray-600">{__tr(language === 'ar' ? "المدينة" : 'City')}</label>
                  <DatabaseLocationInput kind="city" value={formData.city} onChange={e => setFormData({
                  ...formData,
                  city: e.target.value
                })} required />
                </div>
                <div>
                  <label className="text-sm text-gray-600">{__tr(language === 'ar' ? "الدولة" : 'Country')}</label>
                  <DatabaseLocationInput kind="country" value={formData.country} onChange={e => setFormData({
                  ...formData,
                  country: e.target.value
                })} required />
                </div>
                <div>
                  <label className="text-sm text-gray-600">{__tr(language === 'ar' ? "النجوم" : 'Stars')}</label>
                  <Input type="number" min="1" max="5" value={formData.stars} onChange={e => setFormData({
                  ...formData,
                  stars: parseInt(e.target.value)
                })} />
                </div>
                <div>
                  <label className="text-sm text-gray-600">{__tr(language === 'ar' ? "عدد الغرف" : 'Rooms')}</label>
                  <Input type="number" value={formData.rooms_count} onChange={e => setFormData({
                  ...formData,
                  rooms_count: parseInt(e.target.value)
                })} />
                </div>
                <div>
                  <label className="text-sm text-gray-600">{__tr(language === 'ar' ? "السعر/ليلة" : 'Price/Night')}</label>
                  <Input type="number" step="0.01" value={formData.price_per_night} onChange={e => setFormData({
                  ...formData,
                  price_per_night: parseFloat(e.target.value)
                })} />
                </div>
                <div>
                  <label className="text-sm text-gray-600">{__tr(language === 'ar' ? "العملة" : 'Currency')}</label>
                  <CurrencySelect required value={formData.currency} onChange={e => setFormData({
                  ...formData,
                  currency: e.target.value
                })} />
                </div>
                <div>
                  <label className="text-sm text-gray-600">{__tr(language === 'ar' ? "الهاتف" : 'Phone')}</label>
                  <Input value={formData.phone} onChange={e => setFormData({
                  ...formData,
                  phone: e.target.value
                })} />
                </div>
                <div>
                  <label className="text-sm text-gray-600">{__tr(language === 'ar' ? "البريد" : 'Email')}</label>
                  <Input type="email" value={formData.email} onChange={e => setFormData({
                  ...formData,
                  email: e.target.value
                })} />
                </div>
                <div className="col-span-2">
                  <label className="text-sm text-gray-600">{__tr(language === 'ar' ? "العنوان" : 'Address')}</label>
                  <Input value={formData.address} onChange={e => setFormData({
                  ...formData,
                  address: e.target.value
                })} />
                </div>
              </div>
              <RequirementsEditor serviceType="hotel" value={formData.requirements||[]} onChange={requirements=>setFormData({...formData,requirements})}/>
              <Button type="submit" className="w-full bg-[#6B5B95] hover:bg-[#5B4B85]">
                {__tr(editingHotel ? language === 'ar' ? "تحديث" : 'Update' : language === 'ar' ? "إضافة" : 'Add')}
              </Button>
            </form>
          </DialogContent>
        </Dialog>
      </div>

      {__tr(loading ? <div className="flex justify-center py-12"><div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#6B5B95]"></div></div> : <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {__tr(hotels.map(hotel => <div key={hotel.id} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
              <div className="h-40 bg-gradient-to-br from-[#6B5B95] to-[#5B4B85] flex items-center justify-center">
                <Hotel className="w-16 h-16 text-white/50" />
              </div>
              <div className="p-4">
                <h3 className="font-bold text-lg text-gray-800">{__tr(language === 'ar' ? __localizedField(hotel, "name_ar") : hotel.name_en)}</h3>
                <div className="flex items-center gap-1 text-yellow-500 my-2">
                  {__tr(Array.from({
              length: Number(hotel.stars) || 3
            }).map((_, i) => <Star key={i} className="w-4 h-4 fill-current" />))}
                </div>
                <div className="text-sm text-gray-500 space-y-1">
                  <p className="flex items-center gap-2"><MapPin className="w-4 h-4" />{__tr(hotel.city)}{__tr(", ")}{__tr(hotel.country)}</p>
                  {__tr(hotel.phone && <p className="flex items-center gap-2"><Phone className="w-4 h-4" />{__tr(hotel.phone)}</p>)}
                </div>
                <div className="flex items-center justify-between mt-4 pt-4 border-t">
                  <span className="text-lg font-bold text-[#6B5B95]">${__tr(hotel.price_per_night)}/{__tr(language === 'ar' ? "ليلة" : 'night')}</span>
                  <div className="flex gap-2">
                    <Button size="sm" variant="ghost" onClick={() => handleEdit(hotel)}><Edit className="w-4 h-4" /></Button>
                    <Button size="sm" variant="ghost" className="text-red-500" onClick={() => handleDelete(hotel.id)}><Trash2 className="w-4 h-4" /></Button>
                  </div>
                </div>
              </div>
            </div>))}
        </div>)}
    </div>;
};
export default HotelsPage;
